export const orgConfig = {
  organizations: 'safapply',
  product: 'aaa2031d-f9c4-4563-aee2-6ef90b0bc393',
};
